import React from 'react'
import './portfolio.css'
import IMG1 from '../../assets/portfolio_1.png'
import IMG2 from '../../assets/portfolio_2.png'
import IMG3 from '../../assets/portfolio_3.jpeg'

const data = [


  {
    id: 1,
    iamge: IMG2,
    title: 'IT-7 : Order meals and Track progress of order in real-time',
    demo: 'https://play.google.com/store/apps/details?id=com.ultralounge.menuapp'
  },

  {
    id: 3,
    iamge: IMG1,
    title: 'Bloc : Puzzle Game ',
    demo: 'https://play.google.com/store/apps/details?id=com.Mcnuel.bloc'
  },
  {
    id: 2,
    iamge: IMG3,
    title: 'Coretneedle : Rent, Sew and buy clothes from Designers',
    demo: 'https://play.google.com/store/apps/details?id=com.coretneedle.coretneedleapp'
  },
  
]

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">

        {
          data.map(({ id, iamge, title, demo }) => {
            return (
              <article key={id} className='portfolio__item'>
                <div className='portfolio__item-image '>
                  <img src={iamge} alt={title} />
                </div>

                <div>
                  <h3> {title}</h3>

                  <div className="portfolio__item-cta">
                    <a href="https://github.com" className='btn' target="blank">GitHub</a>
                    <a href={demo} className='btn btn-primary' target="blank"> App Link</a>
                  </div>


                </div>

              </article>
            )
          })
        }



      </div>
    </section>
  )
}

export default Portfolio 